import type {Module} from "vuex";
import type {RootState} from "@/store/types";

export interface ConfigUserDelegateState {
    enabled: boolean
}

const delegate: Module<ConfigUserDelegateState, RootState> = {
    namespaced: true,
    state: {
        enabled: false
    },
    getters: {
        enabled: (state): boolean => state.enabled
    },
    mutations: {
        setEnabled: (state, enabled: boolean) => state.enabled = enabled
    },
    actions: {
        setEnabled(context, enabled: boolean) {

            context.commit("setEnabled", enabled);
        },
        clear(context) {

            context.commit("setEnabled", false);
        }
    }
}

export default delegate
